module.exports = __webpack_public_path__ + "static/img/4018.3a00984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4018.png
// module id = 725
// module chunks = 0 1 12